import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "@/api/statusHTTP";

const PREFIX = 'drp/produtos';

export const buscarAnaliseEstoqueProdutoPorFilial = async (params) => {
  const config = {params, headers: iniciarRequisicao()};
  const {data, status} = await api.get(`${PREFIX}/analise-estoque-filiais`, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.produtos;
  }

  logout();
}
